function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.6571 2.43025H16V3.5731H13.6571C13.3714 4.88739 12.2286 5.85882 10.8571 5.85882C9.48571 5.85882 8.34286 4.88739 8.05714 3.5731H0V2.43025H8.05714C8.34286 1.11596 9.48571 0.144531 10.8571 0.144531C12.2286 0.144531 13.3714 1.11596 13.6571 2.43025ZM9.14286 3.00167C9.14286 3.9731 9.88571 4.71596 10.8571 4.71596C11.8286 4.71596 12.5714 3.9731 12.5714 3.00167C12.5714 2.03025 11.8286 1.28739 10.8571 1.28739C9.88571 1.28739 9.14286 2.03025 9.14286 3.00167Z",
  fill: "#899296"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.34286 11.5731H0V10.4302H2.34286C2.62857 9.11596 3.77143 8.14453 5.14286 8.14453C6.51429 8.14453 7.65714 9.11596 7.94286 10.4302H16V11.5731H7.94286C7.65714 12.8874 6.51429 13.8588 5.14286 13.8588C3.77143 13.8588 2.62857 12.8874 2.34286 11.5731ZM6.85714 11.0017C6.85714 10.0302 6.11429 9.28739 5.14286 9.28739C4.17143 9.28739 3.42857 10.0302 3.42857 11.0017C3.42857 11.9731 4.17143 12.716 5.14286 12.716C6.11429 12.716 6.85714 11.9731 6.85714 11.0017Z",
  fill: "#899296"
});

var SvgIconAdjustmentGrey = function SvgIconAdjustmentGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAdjustmentGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_adjustment_grey.e5caa636.svg";
export { ForwardRef as ReactComponent };